import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

import routeConfig from '../../config/routeConfig';

const START_YEAR = 2021;

function CyberFooter() {
	const location = useLocation();
	const currentYear = new Date().getFullYear();
	const yearRange =
		currentYear > START_YEAR
			? `${START_YEAR}-${currentYear}`
			: `${START_YEAR}`;

	if (location.pathname.match(routeConfig.login)) {
		return null;
	}
	if (location.pathname.match(routeConfig.redirectLogin)) {
		return null;
	} else {
		return (
			<div>
				<div className="cyber-spacer small"></div>

				<div className="cyber-container-footer">
					<footer className="cyber-footer">
						<div className="cyber-footer__copyright">
							© CyberSign {yearRange}. Todos los derechos
							reservados.
						</div>
						<div className="cyber-footer__links">
							<Link to={routeConfig.contact}>Contacto</Link>
						</div>
					</footer>
				</div>
			</div>
		);
	}
}

export default CyberFooter;
